import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, SecurityStatement } from 'common/components/layout';
import { getCustomer } from 'redux/customer/actions';

import Questions from './Questions';
import CreateAccount from './components/CreateAccount';
import ReturningCustomer from './components/ReturningCustomer';

class Login extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    const { settings, location } = this.props;
    let redirectTo = '/profile';
    if (location && location.state && location.state.redirectLink) {
      redirectTo = location.state.redirectLink;
    }
    if (location && location.state && location.state.from) {
      redirectTo = location.state.from.pathname;
    }
    if (!settings.data) {
      return (
        <Layout title="Account Login" loading>
          <Title>Account Login</Title>
        </Layout>
      );
    }
    return (
      <Layout title="Account Login">
        <Title>Account Login</Title>
        <div className="c7-account-login">
          <ReturningCustomer redirectLink={redirectTo} />
          <CreateAccount settings={settings} />
        </div>
        <SecurityStatement settings={settings} />
        <Questions settings={settings} />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { getCustomer })(Login);
